import React, { useEffect, useState, useContext } from "react";
import MenuButton from "../MenuButton/MenuButton";
import UserServices from "../../UserServices/UserServices";
import { NoteState } from "../../context/notes/NoteState";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

export default function CashInHand() {
  const { state } = useContext(NoteState);
  const { branch_id } = state;

  const [myBranches, setMyBranches] = useState([]);
  const [formData, setFormData] = useState({
    branch_id: branch_id || "",
    date: new Date().toLocaleDateString("en-CA"),
    opening_cash_amount: 0,
    sale_counter_amount: 0,
    cafe_amount: 0,
    bank_amount: 0,
    other_amount: 0,
    cash_in_bank: 0,
    charity_balance: 0,
    total_amount: 0,
    expense_amount: 0,
    charity_amount: 0,
    gst_amount: 0,
    cash_in_safe_amount: 0,
    cash_in_hand_amount: 0,
    description: "",
  });
  const [loading, setLoading] = useState(false);

  const fetchBranches = async () => {
    try {
      const response = await UserServices.branchName();
      const res = response.data.data;
      const branches = res.map((b) => ({ id: b.id, name: b.name }));
      setMyBranches([{ id: "", name: "Select Branch" }, ...branches]);
    } catch {
      toast.error("Failed to fetch branches", { autoClose: 3000 });
    }
  };

  const fetchopeningBalance = async (branchId, selectedDate) => {
    if (!branchId || !selectedDate) return;
    try {
      const response = await UserServices.fetchopeningBalance(branchId, { date: selectedDate });
      const openingBalance = response.data.success ? response.data.opening_balance : 0;
      setFormData((prev) => ({
        ...prev,
        opening_cash_amount: openingBalance,
      }));
    } catch {
      setFormData((prev) => ({
        ...prev,
        opening_cash_amount: 0,
      }));
      toast.error("Failed to fetch opening balance", { autoClose: 3000 });
    }
  };

  const fetchGSTData = async (branchId, selectedDate) => {
    if (!branchId || !selectedDate) return;
    try {
      const response = await UserServices.getDetailSaleReport(branchId, {
        sdate: selectedDate,
        edate: selectedDate,
        report: "",
        revenueCat: "",
        package_type: "",
      });
      
      if (response.data && response.data.data && response.data.data.detail) {
        // Calculate total tax from the detail array
        const totalTax = response.data.data.detail.reduce((sum, item) => sum + (item.tax || 0), 0);
        
        // Calculate total net price from the detail array
        const totalNetPrice = response.data.data.detail.reduce((sum, item) => sum + (item.net_price || 0), 0);
        
            // Calculate charity amount as 2.5% of total net price
            const charityAmount = totalNetPrice * 0.025;
            
            setFormData((prev) => {
              const next = {
                ...prev,
                gst_amount: Math.round(totalTax),
                charity_amount: Math.round(charityAmount),
              };
              const opening = parseFloat(next.opening_cash_amount) || 0;
              const sale = parseFloat(next.sale_counter_amount) || 0;
              const cafe = parseFloat(next.cafe_amount) || 0;
              const bank = parseFloat(next.bank_amount) || 0;
              const other = parseFloat(next.other_amount) || 0;
              const total = sale + cafe + bank + opening + other;
              const expense = parseFloat(next.expense_amount) || 0;
              const cashInSafe = parseFloat(next.cash_in_safe_amount) || 0;
              return {
                ...next,
                total_amount: Math.round(total),
                cash_in_hand_amount: Math.round(
                  total - (expense + Math.round(charityAmount) + Math.round(totalTax) + cashInSafe)
                ),
              };
            });
      }
    } catch (error) {
      console.error("Error fetching GST data:", error);
      setFormData((prev) => ({
        ...prev,
        gst_amount: 0,
        charity_amount: 0,
      }));
    }
  };

  const fetchCashData = async (branchId, selectedDate) => {
    if (!branchId || !selectedDate) return;
    try {
      const response = await UserServices.getSummerySaleReportAllNew(branchId, {
        sdate: selectedDate,
        edate: selectedDate,
        gender: "",
        pay_met: "",
        package_type: "",
        pending: "",
      });
      
      if (response.data && response.data.immediate && response.data.immediate.length > 0) {
        // Get cash amount from the first immediate entry
        const cashAmount = response.data.immediate[0].Cash || 0;
        
            setFormData((prev) => ({
              ...prev,
              sale_counter_amount: Math.round(cashAmount),
            }));
      }
    } catch (error) {
      console.error("Error fetching cash data:", error);
      setFormData((prev) => ({
        ...prev,
        sale_counter_amount: 0,
      }));
    }
  };

  const fetchExpenseData = async (branchId, selectedDate) => {
    if (!branchId || !selectedDate) return;
    try {
      const response = await UserServices.getExpences(branchId, 9999999999999999999999, 1, {
        startdate: selectedDate,
        enddate: selectedDate,
      });
      
      if (response.data && response.data.data && response.data.data.data) {
        // Cash that left the drawer: payment method Cash, or a counter salary
        // saved as Salary Deduction. A cheque or bank payment stays out.
        const totalExpense = response.data.data.data
          .filter((item) => {
            const category = String(item.category_name || "").toLowerCase().trim();
            if (
              category === "cash_from_bank" ||
              category === "cash from bank" ||
              category === "cash_in-hand" ||
              category === "cash in-hand" ||
              category === "cash in hand"
            ) {
              return false;
            }
            const type = String(item.transaction_type || "");
            const paymentId = Number(item.payment_type_id);
            const paymentName = String(item.payment_type || "").toLowerCase().trim();
            const isCash = paymentId === 31 || paymentName === "cash";
            const isSalaryDeduction =
              paymentId === 83 || paymentName === "salary deduction";
            const isCounter =
              type === "Office Counter" || type === "Sales Counter";
            return isCash || (isCounter && isSalaryDeduction);
          })
          .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);

        setFormData((prev) => {
          const next = {
            ...prev,
            expense_amount: Math.round(totalExpense),
          };
          const opening = parseFloat(next.opening_cash_amount) || 0;
          const sale = parseFloat(next.sale_counter_amount) || 0;
          const cafe = parseFloat(next.cafe_amount) || 0;
          const bank = parseFloat(next.bank_amount) || 0;
          const other = parseFloat(next.other_amount) || 0;
          const total = sale + cafe + bank + opening + other;
          const charity = parseFloat(next.charity_amount) || 0;
          const gst = parseFloat(next.gst_amount) || 0;
          const cashInSafe = parseFloat(next.cash_in_safe_amount) || 0;
          return {
            ...next,
            total_amount: Math.round(total),
            cash_in_hand_amount: Math.round(total - (next.expense_amount + charity + gst + cashInSafe)),
          };
        });
      }
    } catch (error) {
      console.error("Error fetching expense data:", error);
      setFormData((prev) => ({
        ...prev,
        expense_amount: 0,
      }));
    }
  };

  const fetchCafeData = async (branchId, selectedDate) => {
    if (!branchId || !selectedDate) return;
    try {
      const response = await UserServices.getCafeTransactionReport(branchId, {
        sdate: selectedDate,
        edate: selectedDate,
      });
      
      if (response.data && response.data.data && response.data.data.length > 0) {
        // Calculate total received amount from all payment history where payment_method_id = 33 (Credit Card)
        let totalCafeAmount = 0;
        
        response.data.data.forEach(dateGroup => {
          if (dateGroup.data) {
            dateGroup.data.forEach(order => {
              if (order.payment_history) {
                order.payment_history.forEach(payment => {
                  if (payment.payment_method_id === 31) { // Credit Card payments only
                    totalCafeAmount += payment.received || 0;
                  }
                });
              }
            });
          }
        });
        
            setFormData((prev) => ({
              ...prev,
              cafe_amount: Math.round(totalCafeAmount),
            }));
      }
    } catch (error) {
      console.error("Error fetching cafe data:", error);
      setFormData((prev) => ({
        ...prev,
        cafe_amount: 0,
      }));
    }
  };

  const updateCalculations = (updatedData) => {
    const opening = parseFloat(updatedData.opening_cash_amount) || 0;
    const sale = parseFloat(updatedData.sale_counter_amount) || 0;
    const cafe = parseFloat(updatedData.cafe_amount) || 0;
    const bank = parseFloat(updatedData.bank_amount) || 0;
    const other = parseFloat(updatedData.other_amount) || 0;
    const total = sale + cafe + bank + opening + other;
    const charity = parseFloat(updatedData.charity_amount) || 0;
    const expense = parseFloat(updatedData.expense_amount) || 0;
    const gst = parseFloat(updatedData.gst_amount) || 0;
    const cashInSafe = parseFloat(updatedData.cash_in_safe_amount) || 0;

    // Deduct expense + charity + GST + cash in safe (manual)
    const cashInHand = total - (expense + charity + gst + cashInSafe);

    setFormData((prev) => ({
      ...prev,
      total_amount: Math.round(total),
      cash_in_hand_amount: Math.round(cashInHand),
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...formData, [name]: value };
    setFormData(updatedData);

    if (["sale_counter_amount", "cafe_amount", "bank_amount", "expense_amount", "charity_amount", "other_amount", "gst_amount", "cash_in_safe_amount", "opening_cash_amount"].includes(name)) {
      updateCalculations(updatedData);
    }

    if (name === "branch_id" || name === "date") {
      fetchopeningBalance(
        name === "branch_id" ? value : updatedData.branch_id,
        name === "date" ? value : updatedData.date
      );
      fetchGSTData(
        name === "branch_id" ? value : updatedData.branch_id,
        name === "date" ? value : updatedData.date
      );
      fetchCashData(
        name === "branch_id" ? value : updatedData.branch_id,
        name === "date" ? value : updatedData.date
      );
      fetchExpenseData(
        name === "branch_id" ? value : updatedData.branch_id,
        name === "date" ? value : updatedData.date
      );
      fetchCafeData(
        name === "branch_id" ? value : updatedData.branch_id,
        name === "date" ? value : updatedData.date
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Show confirmation dialog
    const confirmed = window.confirm("Do you want to save this Cash In Hand entry?");
    if (!confirmed) {
      return;
    }
    
    setLoading(true);
    try {
      const response = await UserServices.addCashInHand(formData);
      if (response.status === 201) {
        toast.success("Cash In Hand Added Successfully!", { autoClose: 3000 });
        setFormData((prev) => ({
          ...prev,
          sale_counter_amount: 0,
          cafe_amount: 0,
          bank_amount: 0,
          expense_amount: 0,
          description: "",
          other_amount: 0,
          cash_in_bank: 0,
          charity_balance: 0,
          total_amount: 0,
          charity_amount: 0,
          gst_amount: 0,
          cash_in_safe_amount: 0,
          cash_in_hand_amount: 0,
        }));
      } else {
        toast.error("Failed to Add Cash In Hand", { autoClose: 3000 });
      }
    } catch (err) {
      toast.error("Failed to Add Cash In Hand", { autoClose: 3000 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBranches();
    if (branch_id && formData.date) {
      fetchopeningBalance(branch_id, formData.date);
      fetchGSTData(branch_id, formData.date);
      fetchCashData(branch_id, formData.date);
      fetchExpenseData(branch_id, formData.date);
      fetchCafeData(branch_id, formData.date);
    }
  }, [branch_id, formData.date]);

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <MenuButton />
          <div className="card">
            <div className="card-header py-3">
              <div className="row">
                <div className="col-10">
                  <h5 className="mb-0 font-20">Add Cash In Hand</h5>
                </div>
                <div className="col-md-2 d-flex justify-content-end">
                  <Link to="/view-cash-in-hand" className="btn btn-primary btn-sm">
                    View Cash In Hand 
                  </Link>
                </div>
              </div>
            </div>
            <div className="card-body">
              <form className="row g-3" onSubmit={handleSubmit}>
                <div className="col-md-6">
                  <label className="form-label">Branch Name</label>
                  <select
                    className="form-select"
                    name="branch_id"
                    value={formData.branch_id}
                    disabled={!!branch_id}
                    onChange={handleChange}
                  >
                    {myBranches.map((branch) => (
                      <option key={branch.id} value={branch.id}>
                        {branch.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Opening Cash Balance</label>
                  <input
                    type="number"
                    className="form-control"
                    name="opening_cash_amount"
                    value={formData.opening_cash_amount}
                    readOnly
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Sale Counter Amount (Auto)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="sale_counter_amount"
                    value={formData.sale_counter_amount}
                    readOnly
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Cafe Amount (Auto)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="cafe_amount"
                    value={formData.cafe_amount}
                    readOnly
                  />
                </div>

                {[{ label: "Bank Amount", name: "bank_amount" },
                  { label: "Other Amount", name: "other_amount" },
                  { label: "Description", name: "description", type: "text" }
                  // { label: "Cash In Bank", name: "cash_in_bank" },
                  // { label: "Charity Balance", name: "charity_balance" }
                ].map(({ label, name, type = "number" }) => (
                  <div className="col-md-6" key={name}>
                    <label className="form-label">{label}</label>
                    <input
                      type={type}
                      className="form-control"
                      name={name}
                      value={formData[name]}
                      onChange={handleChange}
                    />
                  </div>
                ))}

                <div className="col-md-6">
                  <label className="form-label">Expense Amount (Auto)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="expense_amount"
                    value={formData.expense_amount}
                    readOnly
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">GST Amount (Auto)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="gst_amount"
                    value={formData.gst_amount}
                    readOnly
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Charity Amount (2.5%)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="charity_amount"
                    value={formData.charity_amount}
                    readOnly
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Cash In Safe (Manual)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="cash_in_safe_amount"
                    value={formData.cash_in_safe_amount}
                    onChange={handleChange}
                    min="0"
                    step="1"
                  />
                  <small className="text-muted">
                    Deducted from total like charity and GST
                  </small>
                </div>

                {[{ label: "Total Amount", name: "total_amount" },
                  // { label: "Charity Amount", name: "charity_amount" },
                  { label: "Cash In Hand", name: "cash_in_hand_amount" }
                ].map(({ label, name }) => (
                  <div className="col-md-6" key={name}>
                    <label className="form-label">{label}</label>
                    <input
                      type="number"
                      className="form-control"
                      name={name}
                      value={formData[name]}
                      readOnly
                    />
                  </div>
                ))}

                {[  { label: "Cash In Bank", name: "cash_in_bank" },
                  { label: "Charity Balance", name: "charity_balance" }
                ].map(({ label, name, type = "number" }) => (
                  <div className="col-md-6" key={name}>
                    <label className="form-label">{label}</label>
                    <input
                      type={type}
                      className="form-control"
                      name={name}
                      value={formData[name]}
                      onChange={handleChange}
                    />
                  </div>
                ))}

                <div className="col-md-12">
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Add Cash In Hand"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
      {loading && (
        <div className="loader in">
          <div className="spinner-border main-spin"></div>
        </div>
      )}
    </div>
  );
}
